/**
 * Utilitários para trabalhar com cookies do Facebook (_fbp e _fbc)
 * Esses cookies são usados para melhorar a atribuição de conversões
 */

/**
 * Obtém o valor de um cookie específico
 * @param name Nome do cookie
 * @returns Valor do cookie ou undefined se não existir
 */
const getCookie = (name: string): string | undefined => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop()?.split(';').shift();
    }
    
    return undefined;
};

/**
 * Obtém os cookies do Facebook (_fbp e _fbc)
 * Esses cookies são criados automaticamente pelo pixel do Facebook
 * 
 * @returns Objeto com _fbp e _fbc (se existirem)
 */
export const getFacebookCookies = (): { fbp?: string; fbc?: string } => {
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    
    return {
        fbp,
        fbc
    };
};

/**
 * Obtém o cookie _fbp (Facebook Browser Pixel)
 * Formato: fb.{domain_id}.{timestamp}.{random}
 * Exemplo: fb.1.1234567890123.1234567890
 * 
 * @returns Valor do cookie _fbp ou undefined
 */
export const getFbpCookie = (): string | undefined => {
    return getCookie('_fbp');
};

/**
 * Obtém o cookie _fbc (Facebook Click)
 * Formato: fb.{domain_id}.{timestamp}.{fbclid}
 * Exemplo: fb.1.1234567890123.AbCdEfGh
 * 
 * Este cookie só existe se o usuário veio de um anúncio do Facebook (com fbclid na URL)
 * 
 * @returns Valor do cookie _fbc ou undefined
 */
export const getFbcCookie = (): string | undefined => {
    return getCookie('_fbc');
};
